import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { Component, createRef } from 'react';
import Measure from 'react-measure';
import { safeInvoke } from '../utils';

var Squeezer =
/*#__PURE__*/
function (_Component) {
  _inherits(Squeezer, _Component);

  function Squeezer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Squeezer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Squeezer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "rootRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "measuring", false);

    _defineProperty(_assertThisInitialized(_this), "measurements", []);

    _defineProperty(_assertThisInitialized(_this), "minWidth", 0);

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.measure();
    });

    return _this;
  }

  _createClass(Squeezer, [{
    key: "addMeasurement",
    value: function addMeasurement(width) {
      this.measurements.push(width);

      if (this.measurements.length > 2) {
        this.measurements.shift();
      }
    }
  }, {
    key: "measure",
    value: function measure() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // eslint-disable-next-line react/prop-types
      var _this$props = this.props,
          compact = _this$props.compact,
          uncompact = _this$props.uncompact;

      if (this.measuring && !force) {
        return;
      }

      this.measuring = true;
      var root = this.rootRef.current;
      var width = Math.ceil(root.getBoundingClientRect().width);
      var scrollWidth = Math.ceil(root.scrollWidth);
      var checkForce = false;

      if (width < scrollWidth) {
        if (compact()) {
          this.minWidth = scrollWidth;
          checkForce = true;
        }
      } else if (width > this.minWidth) {
        if (uncompact()) {
          this.minWidth = width;
          checkForce = true;
        }
      }

      this.addMeasurement(width);
      this.check(checkForce);
    }
  }, {
    key: "check",
    value: function check() {
      var _this2 = this;

      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!force && this.measurements.length === 2 && this.measurements[0] === this.measurements[1]) {
        this.measuring = false;
      } else {
        this.setState({}, function () {
          _this2.measure(true);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // eslint-disable-next-line react/prop-types
      var _this$props2 = this.props,
          children = _this$props2.children,
          _innerRef = _this$props2.innerRef,
          innerMeasure = _this$props2.innerMeasure;
      return React.createElement(Measure, {
        onResize: this.handleResize,
        innerRef: function innerRef(el) {
          if (el) {
            _this3.rootRef.current = el;
            safeInvoke(_innerRef, el);
            safeInvoke(innerMeasure, function () {
              _this3.measure(true);
            });
          }
        }
      }, function (_ref) {
        var measureRef = _ref.measureRef;
        return children({
          ref: measureRef
        });
      });
    }
  }]);

  return Squeezer;
}(Component);

export default Squeezer;